/* stylelint-disable max-nesting-depth, selector-max-compound-selectors */

.ux-iws-stateful-overview {
    .gutter-row {
        margin-left: -15px;
        margin-right: -15px;
    }

    ux-iws-stateful-table .ux-iws-async-toggle-button {
        font-size: 21px;
    }

    .section__arrow-down {
        z-index: 1;
    }

    .u-background-blue-gradient {
        position: relative;

        .ux-spinner-overlay {
            position: absolute;
        }

        &.loading {
            > div {
                opacity: 0;
            }
        }
    }

    .empty-results {
        text-align: center;

        ux-icon {
            font-size: 50px;
            color: $color-red-error;
            fill: $color-red-error;
        }
    }

    .results {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .ux-select {
            background: white;
            display: flex;
        }

        ux-button {
            height: 46px;
        }

        .ux-button-group {
            margin-left: 15px;
        }
    }

    &__label-count {
        margin-left: 5px;
    }

    &__sorting-select {
        width: max-content;
    }

    .results__numbers {
        width: 100%;
    }

    &__sorting-select {
        width: max-content;
    }

    .results__sorting {
        align-items: flex-end;
        display: flex;
        flex-direction: column;
        width: 100%;

        &-select {
            display: none;

            @media only screen and (min-width: $tablet) {
                display: block;
            }
        }

        &-select--mobile {
            display: block;

            @media only screen and (min-width: $tablet) {
                display: none;
            }
        }

        @media only screen and (min-width: $tablet) {
            flex-direction: row-reverse;
        }
    }

    .table-detail {
        align-items: center;
        display: flex;
        justify-content: space-between;
    }

    ux-icon[name="circle-cross"] {
        color: $color-red-error;
    }

    .ux-mobile-table__select {
        padding-left: 8.333%;
        padding-right: 8.333%;
    }

    // todo -> remove grid from stateful overview component and conotrol via outer container instead
    .ux-modal-content & {
        .ux-col-10,
        .ux-col-md-10 {
            margin-left: 0;
            width: 100%;
        }
    }
}

/* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
